import type React from 'react';
import { cn } from '@/utils/utils.ts';

function Skeleton({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return <div className={cn('animate-pulse rounded-md bg-[#F9FAFB]', className)} {...props} />;
}

export { Skeleton };
